import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, InjectionToken, Optional, PLATFORM_ID } from '@angular/core';
import { DOMAIN_NAMES } from '../constants/country';

export const WEB_UTILS_REQUEST = new InjectionToken<any>('WEB_UTILS_REQUEST');

@Injectable({
  providedIn: 'root',
})
export class LocationManagerService {
  constructor(@Inject(PLATFORM_ID) private _platformId: Object,
              @Inject('AppConfig') private _appConfig: any,
              @Optional() @Inject(WEB_UTILS_REQUEST) private _request: any) {
  }

  public getDomainName(): DOMAIN_NAMES {
    const host = this.getHost();
    return this._getDomainBasedOnHost(host);
  }

  public navigate(url: string): void {
    if (isPlatformBrowser(this._platformId)) {
      window.location.href = url;
    }
  }

  public getHost(): string {
    if (isPlatformBrowser(this._platformId)) {
      return window.location.host;
    }

    if (isPlatformServer(this._platformId)) {
      return this._getServerHost();
    }

    return '';
  }

  private _getServerHost(): string {
    const host = (this._request?.headers?.origin || this._request?.headers?.host || '').split('?')[0];

    if (!host) {
      return '';
    }

    try {
      const protocol = this._appConfig?.production ? 'https' : 'http';
      return new URL(host.includes('://') ? host : `${protocol}://${host}`).host;
    } catch (e) {
      return host;
    }
  }

  private _getDomainBasedOnHost(host: string): DOMAIN_NAMES {
    const hostname = host.split(':')[0].toLowerCase();
    const parts = hostname.split('.');
    const domain = parts[parts.length - 1] as DOMAIN_NAMES;
    const availableDomains = this._appConfig?.availableDomains;

    if (availableDomains?.length) {
      return availableDomains.includes(domain) ? domain : this._appConfig.defaultDomainName;
    }

    return domain || this._appConfig.defaultDomainName;
  }
}
